import React from 'react';
import styles from './Common.module.css';
import { useTranslation } from 'react-i18next';

import useAuth from '@hooks/useAuth';

const Form = ({ organization }) => {
  const { t } = useTranslation();
  const [{ currentUser }] = useAuth();

  const showDate = (value) => {
    const myDate = new Date(value);
    let m = myDate.getMonth() + 1;
    let d = myDate.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;

    return `${d}.${m}.${myDate.getFullYear()}`;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.line}>
        <span className={styles.title}>
          {t('organization.name.title')}
        </span>

        <span className={styles.name}>
          {organization.name}
        </span>
      </div>

      <div className={styles.line}>
        <span className={styles.title}>
          {t('organization.date.title')}
        </span>

        <span className={styles.name}>
          {showDate(organization.created)}
        </span>
      </div>
    </div>
  )
}

export default Form;
